import { render } from "./RefundRules.vue?vue&type=template&id=40c93ffa&scoped=true"
import script from "./RefundRules.vue?vue&type=script&lang=js"
export * from "./RefundRules.vue?vue&type=script&lang=js"

import "./RefundRules.vue?vue&type=style&index=0&id=40c93ffa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c93ffa"]])

export default __exports__